// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1f2a7cb4","787":"c8fff4d3"}[chunkId] + ".chunk.js";
};